import React from 'react';
import { ChevronRightOutlined } from '@next-common/material-ui-icons';
import { colorPalette } from '../../colorPalette';
import Box from "@mui/material/Box";
export const Breadcrumb = ({ steps }) => {
    if (!steps || steps.length === 0) {
        return null;
    }
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexWrap: 'nowrap',
        } }, steps.map((step, inc) => (React.createElement(Box, { key: step, sx: {
            display: 'inline-flex',
            alignItems: 'center',
            minWidth: inc === 0 ? 'auto' : 0, // Ellipsis on all levels but the first one
        } },
        React.createElement(Box, { component: "span", sx: {
                color: colorPalette.gray600,
                fontSize: 13,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            } }, step),
        inc < steps.length - 1 ? (
        /* @ts-expect-error Type V4 and V5 */
        React.createElement(ChevronRightOutlined, { sx: {
                margin: '0 4px',
                color: colorPalette.gray600,
                display: 'inline',
                height: '12px',
                width: '12px',
            } })) : null)))));
};
